export default "__VITE_ASSET__CeL66745__"